<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
    >
        <situacion-laboral-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>

    import SituacionLaboralProvider from "../../../../providers/SituacionLaboralProvider";
    
    import {CrudCreate, ClientError} from '@dracul/common-frontend'
    
    import SituacionLaboralForm from "../SituacionLaboralForm";
    
    


    export default {
        name: "SituacionLaboralCreate",
         
        components: { SituacionLaboralForm, CrudCreate },
        
        props:{
          open: {type: Boolean, default: true}
        },
        
        data() {
            return {
                title: 'cobrox.situacionLaboral.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    nombre: ''
                }
            }
        },
        
        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    SituacionLaboralProvider.createSituacionLaboral(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.createSituacionLaboral)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

